export default __webpack_public_path__ + "static/media/higher_icon_roi_reversed.2a784282.svg";